<script setup>
import { RouterLink } from 'vue-router'
import { ROUTES } from '../../../core/config/constants.js'
</script>

<template>
  <footer class="home-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-brand">
          <img src="@/assets/logo/logo_76.png" alt="GoFood" class="footer-logo" />
          <span class="footer-brand-text">GoFood</span>
        </div>
        <div class="footer-links">
          <RouterLink :to="{ name: ROUTES.ACCESSIBILITY }">נגישות</RouterLink>
          <RouterLink :to="{ name: ROUTES.CONTACT }">צור קשר</RouterLink>
          <RouterLink :to="{ name: ROUTES.POLICY }">תנאי שימוש</RouterLink>
          <RouterLink :to="{ name: ROUTES.PRIVACY }">פרטיות</RouterLink>
        </div>
        <div class="footer-copyright">
          <p>© 2024 GoFood. כל הזכויות שמורות.</p>
          <p class="footer-powered">Powered by <strong>CyberPark</strong></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

@media (min-width: 768px) {
  .container {
    padding: 0 var(--spacing-lg);
  }
}

.home-footer {
  padding: var(--spacing-lg) 0;
  border-top: 1px solid var(--border-color);
}

@media (min-width: 768px) {
  .home-footer {
    padding: var(--spacing-xl) 0;
  }
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--spacing-md);
}

@media (min-width: 768px) {
  .footer-content {
    flex-direction: row;
    justify-content: space-between;
    text-align: right;
    gap: var(--spacing-lg);
  }
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.footer-logo {
  width: 28px;
  height: 28px;
  border-radius: var(--border-radius-sm);
}

@media (min-width: 768px) {
  .footer-logo {
    width: 32px;
    height: 32px;
  }
}

.footer-brand-text {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
}

@media (min-width: 768px) {
  .footer-brand-text {
    font-size: var(--font-size-lg);
  }
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--spacing-sm) var(--spacing-md);
}

@media (min-width: 768px) {
  .footer-links {
    gap: var(--spacing-lg);
  }
}

.footer-links a {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  text-decoration: none;
  transition: color var(--transition-fast);
}

@media (min-width: 768px) {
  .footer-links a {
    font-size: var(--font-size-sm);
  }
}

.footer-links a:hover {
  color: #334155;
}

.footer-copyright {
  text-align: center;
}

@media (min-width: 768px) {
  .footer-copyright {
    text-align: left;
  }
}

.footer-copyright p {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
  margin: 0;
}

@media (min-width: 768px) {
  .footer-copyright p {
    font-size: var(--font-size-sm);
  }
}

.footer-powered {
  font-size: 10px;
  margin-top: 2px;
}

@media (min-width: 768px) {
  .footer-powered {
    font-size: var(--font-size-xs);
    margin-top: 4px;
  }
}

.footer-powered strong {
  color: #f59e0b;
}
</style>
